var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mt-0 pa-0",attrs:{"width":_vm.width,"height":_vm.height,"color":"transparent rounded-0"}},[_c('iframe',{ref:"refMap",staticStyle:{"background-color":"#37474F"},attrs:{"width":"100%","height":"97%","frameborder":"1","referrerpolicy":"no-referrer-when-downgrade","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }